module.exports = __webpack_public_path__ + "static/media/seramek.ad0fde2c.jpeg";